/* eslint-disable max-len */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { MLProductCodeUtil, MLQuoteNameUtil, MLLocalDateUtil } from 'ml-portals-util-js';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import Person from './Person';
import Contact from './Contact';
import PolicyLineExtensionConfiguration from '../PolicyLineExtensionConfiguration';

const PORTAL_CODE = appConfig.portalCode;

function Submission(data) {
    // PROCESS
    if (data) {
        data.persons = [];

        data.baseData.accountHolder = this._forcePerson(data, data.baseData.accountHolder);
        if (data.baseData.accountHolder) {
            if (!data.baseData.accountHolder.subtype) {
                data.baseData.accountHolder.subtype = 'Person';
            }
            data.baseData.accountHolder.accountHolder = true;

            if (!data.baseData.policyAddress.addressType) {
                data.baseData.policyAddress.addressType = 'home';
            }

            // Sanitisation for data coming from core products. This can cause problems returning to backend
            _.map(['prefix', 'suffix', 'middleName'], (key) => {
                if (!data.baseData.accountHolder[key]) {
                    data.baseData.accountHolder[key] = undefined;
                }
            });
        }

        // add SNI to persons list
        if (data.baseData.secondaryNamedInsured_ML) {
            data.baseData.secondaryNamedInsured_ML = this.findPerson(data, data.baseData.secondaryNamedInsured_ML);
        }

        _.extend(this, data);
        _.map(this.persons, (p) => {
            _.map(['prefix', 'suffix', 'middleName'], (key) => {
                if (!p[key]) {
                    p[key] = undefined;
                }
            });
        });
    } else {
        const startYear = new Date();
        this.baseData = {
            accountHolder: {
                subtype: 'Person',
                accountHolder: true
            },
            periodStartDate: {
                year: startYear.getFullYear(),
                month: startYear.getMonth(),
                day: startYear.getDate()
            },
        };
    }
    this.baseData.questionSetNames = [];
    this.baseData.portalCode_ML = PORTAL_CODE;

    PolicyLineExtensionConfiguration.mixinLobBaseDataExtensions(this);
}

Submission.prototype.createId = function () {
    return EntityUtil.nextId();
};

Submission.prototype.nextId = function () {
    return EntityUtil.nextId();
};

// PERSON
Submission.prototype.createPerson = function (/* options */) {
    const person = new Person({
        tempID: EntityUtil.nextId()
    });
    this.persons.push(person);
    return person;
};

// UTILS
Submission.prototype.isBound = function () {
    return this.bindData && this.bindData.policyNumber;
};

Submission.prototype.getAccountHolderPerson = function () {
    return this.baseData.accountHolder;
};

Submission.prototype.getPrimaryNamedInsured = function () {
    return this.baseData.primaryNamedInsured_ML;
};

Submission.prototype.submissionExists = function () {
    return !!this.quoteID;
};

Submission.prototype.findPerson = function (submission, person) {
    if (_.isEmpty(person)) {
        return null;
    }

    return this._forcePerson(submission, person);
};

Submission.prototype._forcePerson = function (submission, person) {
    let p = person.publicID ? submission.persons.find((pers) => pers.publicID === person.publicID) : null;
    if (!p) {
        submission.baseData.productCode === 'PersonalUmbrella' ? p = new Contact(person) : p = new Person(person);
        p.tempID = EntityUtil.nextId();
        p.displayName = p.getDisplayName();
        p.emailAddress_ML = p.emailAddress_ML || person.emailAddress1;
        submission.persons.push(p);
    }
    return p;
};

Submission.prototype.isHomeOwners = function () {
    return MLProductCodeUtil.isHomeOwners(this.baseData.productCode);
};

Submission.prototype.isRenters = function () {
    return this.isHomeOwners()
            && MLProductCodeUtil.isHomeOwnersPartialTypeRental(this.lobData.homeowners.coverables.coveragePartType_ML);
};

Submission.prototype.isDwelling = function () {
    return this.isHomeOwners()
            && MLProductCodeUtil.isHomeOwnersPartialTypeHome(this.lobData.homeowners.coverables.coveragePartType_ML);
};

Submission.prototype.isCondo = function () {
    return this.isHomeOwners()
            && MLProductCodeUtil.isHomeOwnersPartialTypeCondo(this.lobData.homeowners.coverables.coveragePartType_ML);
};

Submission.prototype.isLandlordCondo = function () {
    return this.isHomeOwners()
            && MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(this.lobData.homeowners.coverables.coveragePartType_ML);
};

Submission.prototype.isLandlordHome = function () {
    return this.isHomeOwners()
            && MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(this.lobData.homeowners.coverables.coveragePartType_ML);
};

Submission.prototype.isPersonalAuto = function () {
    return MLProductCodeUtil.isPersonalAuto(this.baseData.productCode);
};

Submission.prototype.isPersonalUmbrella = function () {
    return MLProductCodeUtil.isPersonalUmbrella(this.baseData.productCode);
};

Submission.prototype.getProductName = function () {
    return this.isHomeOwners()
        ? MLQuoteNameUtil.getCoveragePartTypeName(this.lobData.homeowners.coverables.coveragePartType_ML)
        : MLQuoteNameUtil.getProductName(this.baseData.productCode);
};

Submission.prototype.beforeSave = function () {
    if (this.baseData.lobs) {
        _.every(this.baseData.lobs, (lob)=> {
            return _.isFunction(lob.beforeSave) ? lob.beforeSave() : true;
        });
    }
    delete (this.script_ML); // US20414 Don't send the script back
    delete (this.hvqDiscrepancies_ML);
};

Submission.prototype.isQuoted = function () {
    return this.baseData.status_ML === 'Quoted';
};

Submission.prototype.hasRateAsOfDateExpired = function () {
    return this.quoteData && this.quoteData.offeredQuotes
            && this.quoteData.offeredQuotes.some((quote) => !!quote.rateAsOfDateExpired_ML);
};

Submission.prototype.hasEffectiveDateChanged = function () {
    return this.quoteData && this.quoteData.offeredQuotes
            && this.quoteData.offeredQuotes.some((quote) => MLLocalDateUtil.localDate2Date(quote.periodStartDate).getTime() !== MLLocalDateUtil.localDate2Date(this.baseData.periodStartDate).getTime());
};

Submission.prototype.isCompRater = function () {
    return !!this.hvqQuoteID_ML;
};

Submission.prototype.isConsumerCompRater = function () {
    return this.isCompRater() && !this.isSubmitAgent;
};

/**
     * This function may be called to clean Comp Rater's mock policy numbers
     * Mock numbers are created on the Comp Rater side to pass the Portals validation
     */
Submission.prototype.cleanUpCompRaterMockPolicyNumbers = function () {
    if (!this.isCompRater()) {
        return;
    }
    const cleanMockPolicy = (policyNumber) => (policyNumber
        ? policyNumber.replace(/[AH]123456789/, '')
        : null);

    if (this.isPersonalAuto()) {
        const modifiers = this.lobData.personalAuto.modifiers_ML;
        modifiers.homePolicyNumber = cleanMockPolicy(modifiers.homePolicyNumber);
    } else if (this.isHomeOwners()) {
        const modifiers = this.lobData.homeowners.modifiers_ML;
        modifiers.autoPolicyNumber_ML = cleanMockPolicy(modifiers.autoPolicyNumber_ML);
        modifiers.homePolicyNumber_ML = cleanMockPolicy(modifiers.homePolicyNumber_ML);
    }
};

export default Submission;
